import { propertyTypes } from "@app/property";
import { propertyGroupTypes } from "@app/propertyGroup";
import { createContext } from "react";

import { PropertyProviderModes } from "../constants/PropertyProviderModes";

interface IPropertyContext {
    propertyGroupId: string | undefined;
    activePropertyId: string | undefined;
    propertyGroup: propertyGroupTypes.IPropertyGroup | undefined;
    activeProperty: propertyTypes.IProperty | undefined;
    allProperties: propertyTypes.IProperty[] | undefined;
    isActivePropertyFetched: boolean;
    isActivePropertyLoading: boolean;
    forceIbeReset: boolean;
    firstStep: string;
    forceActivePropertyIdTo: (propertyId: string) => void;
    propertyResolverMode: PropertyProviderModes;
    changeActivePropertyId: (propertyId: string) => void;
}

export const PropertyContext = createContext<IPropertyContext | undefined>(undefined);
